import { getContactFormHTML, bindContactFormEvents } from '../../../apps/main/src/pages/contact.js';

export function initModalsAndDrawers(siteData) {
  // Inject Modal and Drawer containers into the DOM
  const containerHTML = `
    <div id="contact-modal-overlay" class="modal-overlay">
      <div class="modal-content">
        <button id="close-modal-btn" class="close-btn">&times;</button>
        <div id="modal-form-container"></div>
      </div>
    </div>
    
    <div id="contact-side-drawer" class="side-drawer">
      <div class="drawer-header">
        <h3 style="margin:0; font-size:1.2rem;">Quick Connect</h3>
        <button id="close-drawer-btn" class="close-btn">&times;</button>
      </div>
      <div class="drawer-body" id="drawer-form-container"></div>
    </div>
  `;
  
  document.body.insertAdjacentHTML('beforeend', containerHTML);

  const modalOverlay = document.getElementById('contact-modal-overlay');
  const modalFormContainer = document.getElementById('modal-form-container');
  const closeModalBtn = document.getElementById('close-modal-btn');
  
  const sideDrawer = document.getElementById('contact-side-drawer');
  const drawerFormContainer = document.getElementById('drawer-form-container');
  const closeDrawerBtn = document.getElementById('close-drawer-btn');

  function openModal() {
    if (!modalFormContainer.innerHTML) {
      let html = getContactFormHTML(siteData, 'modal', true);
      html = html.replace(/animate-on-scroll/g, ''); // Fix invisibility bug
      modalFormContainer.innerHTML = html;
      bindContactFormEvents('modal');
    }
    modalOverlay.classList.add('active');
  }

  function closeModal() {
    modalOverlay.classList.remove('active');
  }

  function openDrawer() {
    if (!drawerFormContainer.innerHTML) {
      let html = getContactFormHTML(siteData, 'drawer', true);
      html = html.replace(/animate-on-scroll/g, ''); // Fix invisibility bug
      drawerFormContainer.innerHTML = html;
      bindContactFormEvents('drawer');
    }
    sideDrawer.classList.add('active');
  }

  function closeDrawer() {
    sideDrawer.classList.remove('active');
  }

  // Bind Close Buttons
  closeModalBtn.addEventListener('click', closeModal);
  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closeModal();
  });
  closeDrawerBtn.addEventListener('click', closeDrawer);

  // Intercept "Contact Us" links to open modal instead of scrolling
  document.addEventListener('click', (e) => {
    const target = e.target.closest('a');
    if (target) {
        const href = target.getAttribute('href');
        
        if (href === '/#contactUs' || href === '#contactUs') {
          if (window.location.pathname !== '/contactUs.html') {
              e.preventDefault();
              openModal();
          }
        }
    }
  });

  // Automatically open the side drawer after 10 seconds (once per session)
  // Disabled on drive subdomain — it's a web app, not a marketing page
  const isDriveSubdomain = window.location.hostname.startsWith('drive.');
  if (!isDriveSubdomain && !sessionStorage.getItem('drawer_shown')) {
    setTimeout(() => {
      openDrawer();
      sessionStorage.setItem('drawer_shown', 'true');
    }, 10000);
  }

}
